import { useSamplesWaterBaseDataCreateMutation } from "@/services/backend/samples/api/water-base-data-api";
import { CreateSampleBaseDataDialog } from "@/services/backend/samples/components/create-sample-base-data-dialog";

export function CreateWaterBaseDataDialog() {
  const mutation = useSamplesWaterBaseDataCreateMutation();
  return <CreateSampleBaseDataDialog mutation={mutation} />;
}
